
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { USER_PROFILE } from "../Utils";

const Popup = () => {
  const [show, setShow] = useState(true);
  const [getLogin, setGetLogin] = useState({});
  const [loginResponse, setLoginResponse] = useState(null);

  const nav = useNavigate();
  const { instance } = useMsal();

  const handleClose = () => {
    setShow(false); 
    sessionStorage.clear();
    localStorage.removeItem('authToken');
    sessionStorage.clear();
    window.location.href = '/';

    // instance.logoutRedirect({
    //   postLogoutRedirectUri: window.location.origin,
    // });
  };

  // Logout from Microsoft and redirect to Login page
  const handleLogout = () => {
    sessionStorage.clear();

    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  useEffect(() => {
    const userProfileJSON = sessionStorage.getItem(USER_PROFILE);

    if (userProfileJSON) {
      const userDataObject = JSON.parse(userProfileJSON);
      setGetLogin(userDataObject);
    }

    const responseData = sessionStorage.getItem("loginResponse");

    if (responseData) {
      setLoginResponse(JSON.parse(responseData));
    }
  }, []);

  // Handle browser back button
  useEffect(() => {
    const handleBackButton = () => {
      nav("/", { replace: true });
    };

    window.history.pushState(null, "", window.location.pathname);

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [nav]);

  const handleProceed = (item) => {
    sessionStorage.setItem("itemClicked", item);

    if (item === "centralStore") {
      nav("/CentralStoreDashboard");
    }

    if (item === "rmTracking") {
      nav("/RMDashboard");
    }

    if (item === "farmOperations") {
      nav("/FarmOperationDashboard");
    }
  };

  return (
    <div>
      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        size="lg"
        className="custom-modal modalBlur"
        onHide={handleClose}
        centered
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1050,
        }}
      >
        <Modal.Header className="border-0 d-flex justify-content-center bg-color-black">
          <Modal.Title></Modal.Title>

          {/* <Button
            variant="link"
            className="close btn btn-danger close_btn"
            onClick={handleClose}
          >
            X
          </Button> */}
        </Modal.Header>

        <Modal.Body className="pl-md-5 pr-md-5 pt-0">
          {loginResponse?.statusCode === "101" ? (
            <div className="text-center p-4">
              <h5 className="text-danger">
                {loginResponse.message}
              </h5>
              {/* 
              <Button
                variant="primary"
                className="mt-3"
                onClick={handleLogout}
              >
                OK
              </Button> */}
              <Button
                variant="primary"
                className="mt-3"
                onClick={handleClose}
              >
                OK
              </Button>
            </div>
          ) : (
            <div>
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th className="text-center">Name</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {getLogin?.userMenuControl &&
                    Object.keys(getLogin.userMenuControl)
                      .filter((key) => {
                        return (
                          (getLogin.centralStore &&
                            key === "centralStore") ||
                          (getLogin.farmOperations &&
                            key === "farmOperations") ||
                          (getLogin.rmTracking &&
                            key === "rmTracking")
                        );
                      })
                      .map((item, roleIndex) => {
                        const label =
                          item === "centralStore"
                            ? "Central Store"
                            : item === "farmOperations"
                              ? "Farm Operations"
                              : item === "rmTracking"
                                ? "R&M Tracking"
                                : "";

                        return (
                          <tr key={roleIndex}>
                            <td>{roleIndex + 1}</td>

                            <td className="text-center">
                              {label}
                            </td>

                            {/* <td className="text-center">
                              <button
                                className="popupBtn btn btn-success btn-sm"
                                onClick={() =>
                                  handleProceed(item)
                                }
                              >
                                Proceed
                              </button>
                            </td> */}

                            <td className="text-center">
                              <button
                                className="popupBtn btn btn-sm"
                                style={{
                                  backgroundColor: "#4A7729",
                                  borderColor: "#4A7729",
                                  color: "#fff",
                                }}
                                onClick={() => handleProceed(item)}
                              >
                                Proceed
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Popup;
